import { Component } from '@angular/core';
import { membersuiteDueToDueFromEntryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Due To Due From Entries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteduetoduefromentry-form',
    templateUrl: './membersuiteduetoduefromentry.form.component.html'
})
export class membersuiteDueToDueFromEntryFormComponent extends BaseFormComponent {
    public record!: membersuiteDueToDueFromEntryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

